/** @jsx jsx */

import { Fragment as _, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import FullPageText from './FullPageText';
import { imgPlaceholders } from 'components/lib/Image';
import FullPageTextBackground from 'assets/Full_Background_b.svg';

const Components = {
  Row,
  Column,
  Text: EditableText,
  FullPageText,
  Image: ({ children, ...props }) => {
    return (
      <Image
        {...{
          ...props,
          placeholder: imgPlaceholders[1],
          usePlaceholderValue: true,
        }}
      />
    );
    //
  },
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Video,
  SVG,
  Media,
};

const FullPageTextDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const interactionBlockProps = {
    // backgroundImagePlaceholder: FullPageTextBackground,
    ...interactionBlock.props,
  };

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlockProps}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default FullPageTextDisplay;
